import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {IHolidayCalendarStoreData, IHolidayCalendarData} from './types';
import { AppState } from '../../../verticals/dweb-cars/src/store';
import {updateHolidayCalendarDataAction} from './actions';
import { getHolidayCalendarApi } from '../../../verticals/dweb-cars/src/shared/common/redux/thunks';

export const getHolidayCalendarDataThunk = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    getHolidayCalendarApi()
      .then((response: IHolidayCalendarStoreData) => {
        if (response?.success && response?.data && response?.data?.calendar_json) {
          dispatch(
            updateHolidayCalendarDataAction(response.data.calendar_json as IHolidayCalendarData),
          );
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};
